// extracted by mini-css-extract-plugin
export default {"SelectComponent":"Select_SelectComponent__KKRfx","errorMsg":"Select_errorMsg__gO-T-"};